import { ViewerFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/ViewerFragment";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import { useMediaById } from "@coworker/app/src/components/RoomSettings/hooks/useMediaById";
import { useTranslation } from "@coworker/locales";
import TitledText from "../../../TitledText/TitledText";
import LoadingViewerFragment from "../LoadingViewerFragment/LoadingViewerFragment";

export type MediaLocationViewerFragmentConfigProps = {
  field: string;
  title: string;
};

type MediaLocationViewerFragmentProps = {
  configProps: MediaLocationViewerFragmentConfigProps;
  commonProps: ViewerFragmentCommonProps;
};

function MediaLocationViewerFragment({
  configProps,
  commonProps,
}: MediaLocationViewerFragmentProps) {
  const { field, title } = configProps;
  const { task } = commonProps;
  const mediaId = getTypedValue<string>(getByPath(task, field));
  const hasMediaId = typeof mediaId === "string" && mediaId.length > 0;
  const { data: mediaResponse, isLoading: isMediaLoading } = useMediaById(
    hasMediaId ? mediaId : null
  );
  const { t } = useTranslation();

  if (isLoading(mediaId)) {
    return <LoadingViewerFragment />;
  }

  if (!hasMediaId) {
    return null;
  }

  if (isMediaLoading) {
    return <LoadingViewerFragment />;
  }

  const mediaName = mediaResponse?.media?.name?.trim() ?? "";
  if (mediaName.length === 0) {
    return null;
  }

  return <TitledText title={t(title)} text={mediaName} />;
}

export default MediaLocationViewerFragment;
